module.exports = __webpack_public_path__ + "media/images/icons/list-rich-41507e1b92dc46ed18c3e75959a6c8d4.svg";